export default {
  LOAD_LIST_PARAMETER(state, data) {
    state.listaParametros = data
  },
  PREPARE_TO_EDIT_PARAMETER(state, data) {
    state.parametro = data
  },
  RESET_PARAMETER(state) {
    state.parametro = {
      tipo: '',
      lista: true,
      nome: '',
      valor: '',
      comentario: '',
    }
  },
}
